<template>
    <div id="admission">
        <Banner title="投稿專區" :breadcrumbs="breadcrumbs" type="submission"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Admission" chtFirst="錄取" chtSecond="名單" :center="true"></Title>
            </div>
            <section class="list_box" v-if="!Detail.Id">
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    v-show="list.length > 0"
                >
                    <div class="item" v-for="(item,index) in list" :key="item.Id">
                        <ImageCard :data="item" type="admission"></ImageCard>
                    </div>
                </div>
                <notfound v-if="list.length == 0" info="目前尚無錄取名單，"></notfound>
            </section>
            <section v-if="Detail.Id">
                <div class="box">
                    <h3 class="title">{{Detail.Title}}</h3>
                    <div class="img">
                        <img :src="Detail.Image" :alt="Detail.Title" />
                    </div>
                    <div class="border"></div>
                    <div class="tr">
                        <div>投稿日期</div>
                        <div>{{$moment(Detail.StartOn).format("YYYY-MM-DD") + " ~ " +$moment(Detail.EndOn).format("YYYY-MM-DD")}}</div>
                    </div>
                    <div class="content">{{Detail.Introduction}}</div>
                    <div class="adlist">
                        <div class="subtitle">入選名單</div>
                        <div class="admission_content" v-html="Detail.AdmissionContent"></div>
                    </div>
                </div>
                <graybtn name="回列表頁" url="back" />
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import ImageCard from "@/components/submission/imgCard";
import API from "@/service/submission";
export default {
    name: "admission",
    components: {
        ImageCard
    },
    props: ["propsubmission"],
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "投稿專區"
                },
                {
                    url: "/admission",
                    title: "錄取名單"
                }
            ],
            Page: 1,
            Count: 10,
            totalpage: 1,
            busy: true,
            list: [],
            submissionId: "",
            Detail: {
                Id: "",
                Title: "",
                Image: "",
                StartOn: "",
                EndOn: "",
                Content: "",
                AdmissionContent: ""
            },
            Adlist: [
                {
                    Name: "卓婉華",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "陳延制",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "林泰勤",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "張欣怡",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "許敏彥",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "賴佐廷",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "吳安倫",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                },
                {
                    Name: "塵世周",
                    Info:
                        "南臺灣病毒相關之前葡萄膜炎的流行病及臨床表徵-已PCR維診斷工具",
                    Location: "高雄長坑紀念醫院"
                }
            ],
            isLoading: false
        };
    },
    methods: {
        back() {
            window.history.go(-1);
        },
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (vm.totalpage == vm.Page) {
                return false;
            }
            vm.isLoading = true;
            vm.Page += 1;
            API.getAdmissionList({ page: vm.Page, count: vm.Count }).then(
                res => {
                    if (res.Ok) {
                        vm.list = vm.list.concat(res.Data.Submissions);
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                }
            );
        },
        getParamsId(name){
            var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results == null){
                return null;
            }
            else {
                return decodeURI(results[1]) || 0;
        }
        },
    },
    computed: {},
    created() {
        const vm = this;
        let UrlString = location.href;
        let Url = new URL(UrlString);
        let Id = vm.getParamsId('Id');
        if (Id !== null) {
            if (process.env.NODE_ENV === "production") {
                API.getSubmissionDetail({ Id: Id }).then(res => {
                    if (res.Ok) {
                        vm.Detail = res.Data;
                    } else {
                        location.href = "/Submission/Admission";
                    }
                });
            } else {
                vm.Detail = {
                    Id: "123easu65",
                    Title: "艾利根論文獎甄選活動!!",
                    Image: require("@/assets/dev/img2.png"),
                    StartOn: "2019-01-07T00:00:00",
                    EndOn: "2019-02-13T00:00:00",
                    AdmissionContent:
                        '<img src="https://retinasociety.blob.core.windows.net/submission/1cdbb326-0cd8-4f14-b789-05b278ee191d/567f4f3028a542e2927cfc44f7724853.png" alt="X" />',
                    Content: `<p>各位醫師 您好:</p>
              <p>
                今年的第八屆TRS年會將會與第十五屆世界眼炎醫學會年會「15th International Ocular Inflammation Society (IOIS) Congress」假高雄展覽館合辦。其中IOIS會期為108年11月13日至16日(星期三至星期六)，而
                <strong>TRS年會將會於民國108年11月16日(星期六)舉辦</strong>，年會中包含一Free Paper Presentation時段，題目不拘，預定講者八名。另今年第四屆台日聯合會將會同日本視網膜醫學會年會(108年12月6日至8日)在日本長崎舉辦，同往例包含Rapid Fire單元，題目不拘，預定講者八名。
              </p>
              <p>本會現針對第八屆視網膜醫學會年會Free Paper及第四屆台日聯合會Rapid Fire舉辦聯合徵稿活動，在此敬邀各位會員踴躍投稿。投稿注意事項如下</p>
              <ul>
                <li>(一) 投稿台日Rapid-Fire並獲選報告者，將依據往例日方提供報名費及住宿，本會提供新台幣一萬元整交通補助。</li>
                <li>(二) 第一階段評選: 無論投稿Free Paper或Rapid Fire，Abstract篩選獲選者，需於108年8月4日本年度第二次Retina club中報告，並由本會學術委員會選出最終適合報告之論文。</li>
                <li>
                  (三) 今年在諾華公司贊助下，設立「影像與疾病趨勢專題」研究獎，學術委員會及評審將就108年8月4日之預報內容評審，選出nAMD研究組兩名DR/DME研究組兩名，共計四名得獎者，
                  <span
                    style="backgroundColor:#ff0;"
                  >各頒予NTD 20,000現金</span>。申請人須為該論文之第一作者，且該研究需為台灣本土之研究資料，尚未於其他處發表。評選內容將同時依據摘要與上台報告時呈現之影像及內容評之。
                </li>
                <li>
                  (四) 敬請各位會員於
                  <strong>6月20日</strong>前填好abstract form (如附件)電郵交付TRS辦公室，投稿時務必註明想在台日報告、想在IOIS報告、或均可。
                </li>
              </ul>
              <p>另本會今年協辦第十五屆IOIS Congress，秘書處在此亦鼓勵各位會員及所屬住院醫師踴躍報名參加及投稿，其中Abstract投稿現已開放，截止日期為6月1日。</p>
              <p>
                相關投稿事項請至IOIS網站:
                <a
                  href="https://www.iois.info/page.php?edi_id=1463"
                >https://www.iois.info/page.php?edi_id=1463</a>。本會為鼓勵住院醫師多參與此次會議，凡住院醫師投稿IOIS獲選者，學會即補助會議報名費NTD 3,000元整。(本國住院醫師報名費早鳥價150 EURO)
              </p>
              <p>這些會議均是千載難逢與國際專家交流的好機會，歡迎大家多多踴躍參與投稿，千萬不要錯過囉!!</p>
              <p>中華民國視網膜醫學會 陳世真 理事長</p>
              <p>第八屆會員大會暨學術演講會/第15屆IOIS醫學會年會</p>
              <p>許淑娟 會長 敬邀</p>`
                };
            }
        } else {
            if (process.env.NODE_ENV === "production") {
                let obj = JSON.parse(vm.propsubmission);
                vm.list = obj.Submissions;
                vm.totalpage = Math.ceil(parseInt(obj.Total) / vm.Count);
                if (vm.totalpage == 1) {
                    vm.busy = false;
                }
            } else {
                vm.list = [
                    {
                        Id: "123asd3t",
                        Title: "艾利根論文獎甄選活動!!",
                        Image: require("@/assets/dev/img2.png")
                    },
                    {
                        Id: "21345sdf",
                        Title: "台日聯合會議-投稿",
                        Image: require("@/assets/dev/img3.png")
                    },
                    {
                        Id: "65yasrr32",
                        Title:
                            "第八屆視網膜醫學會年會Free Paper 及第四屆台日聯合會Rapid Fire聯合徵稿活動!!",
                        Image: require("@/assets/dev/img4.png")
                    }
                ];
            }
        }
    },
    mounted() {},
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#admission .list_box {
    margin-bottom: 60px;
}
#admission .list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 60px;
}
#admission .list:after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#admission .list .item {
    width: 30%;
    max-width: 350px;
}
#admission .box {
    border: 8px solid #eee;
    padding: 20px 30px;
    display: flex;
    flex-direction: column;
}
#admission .box .title {
    letter-spacing: 2px;
    line-height: 1.5;
    text-align: center;
    margin-bottom: 30px;
}
#admission .box .img {
    font-size: 0;
    width: 300px;
    margin: auto;
}
#admission .box .img img {
    width: 100%;
}
#admission .box .border {
    width: 100%;
    background-color: #ddd;
    height: 1px;
    margin: 30px auto;
}
#admission .box .tr {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #666;
    flex-wrap: wrap;
    /* justify-content: space-between; */
}
#admission .box .tr > div:nth-child(1) {
    background: #eee;
    padding: 16px 12px;
    margin-right: 15px;
}
#admission .box .tr > div:nth-child(2),
#admission .box .tr > a {
    border-bottom: 1px solid #eee;
    text-decoration: none;
    padding: 16px 12px;
    color: #666;
    flex: 1;
}
#admission .box .content {
    color: #666;
    padding: 30px 0;
    line-height: 1.5;
    letter-spacing: 2px;
}
#admission .box .content >>> p,
#admission .box .content >>> p span,
#admission .box .content >>> ul {
    padding: 10px 0;
    line-height: 1.5;
    letter-spacing: 2px;
}
#admission .box .content >>> ul li {
    padding: 8px 0;
}
#admission .box .content >>> strong {
    font-weight: 600;
    color: #000;
}
#admission .box .btn_box {
    width: 165px;
    margin: 15px 0;
}
#admission .box .adlist .subtitle {
    color: #ee8b59;
    font-size: 1.2rem;
    border-bottom: 1px solid #eee;
    padding: 16px 0px;
}
#admission .box .adlist >>> .admission_content {
    width: 100%;
    word-wrap: break-word;
}
#admission .box .adlist >>> .admission_content img {
    width: 100%;
}
#admission .box .adlist >>> .admission_content span,
#admission .box .adlist >>> .admission_content p {
    line-height: 1.5;
    letter-spacing: 2px;
}
#admission .box .adlist ul {
    width: 100%;
    margin-bottom: 40px;
}
#admission .box .adlist ul li {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 24px 0;
    border-bottom: 1px solid #eee;
    color: #666;
    line-height: 1.5;
    letter-spacing: 2px;
}
#admission .box .adlist ul li .name {
    width: 100px;
    text-align: center;
}
#admission .box .adlist ul li .info {
    width: calc(100% - 265px);
}
#admission .box .adlist ul li .location {
    width: 150px;
    margin-left: 15px;
}
@media screen and (max-width: 992px) {
    #admission .list .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #admission .box {
        padding: 20px 10px;
    }
    #admission .list .item {
        width: 100%;
        max-width: none;
    }
    #admission .box .img {
        width: 100%;
    }
    #admission .box .tr > div:nth-child(1) {
        background: #eee;
        padding: 16px 12px;
        width: 100%;
        margin-right: 0;
    }
    #admission .box .tr > div:nth-child(2),
    #admission .box .tr > a {
        border-bottom: 1px solid #eee;
        text-decoration: none;
        padding: 16px 12px;
        color: #666;
        flex: 1;
    }
    #admission .box .adlist ul li .name {
        width: 100%;
        text-align: left;
        margin-bottom: 30px;
    }
    #admission .box .adlist ul li .info {
        width: 100%;
        margin-bottom: 30px;
    }
    #admission .box .adlist ul li .location {
        width: 150%;
        margin-left: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/admission.vue